import { createApi } from '@reduxjs/toolkit/query/react';
import type { Pagination, TypedListResponse, User } from '@skyrise-eng/types';
import { baseQuery } from './baseQuery';
import { buildQueryString } from '@/utils';
import { TAG } from '@/constants';
import { CreateUserPayload } from '@/models';

const USER_URL = 'users/api/v1';

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  tagTypes: [TAG.USER],
  baseQuery,
  endpoints: (builder) => ({
    getUserList: builder.query<TypedListResponse<User>, Partial<Pagination>>({
      query: (params) => `${USER_URL}/list?${buildQueryString(params)}`,
      providesTags: [TAG.USER]
    }),
    createUser: builder.mutation<User, CreateUserPayload>({
      query: (user) => ({
        url: USER_URL,
        method: 'POST',
        body: user
      }),
      invalidatesTags: [TAG.USER]
    }),
    updateUser: builder.mutation<User, User>({
      query: ({ _id, ...rest }) => ({
        url: `${USER_URL}/${_id}`,
        method: 'PUT',
        body: rest
      }),
      invalidatesTags: [TAG.USER]
    }),
    deleteUser: builder.mutation<User, string>({
      query: (id) => ({
        url: `${USER_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [TAG.USER]
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserListQuery, useCreateUserMutation, useUpdateUserMutation, useDeleteUserMutation } =
  userApi;
